export enum AssetTypeFilterEnum {
  Asset_Type = "assetType",
  Custom_Assets = "isCustomAssetType",
  Business_Unit = "businessUnit",
  Technology_ID = "technologyId",
  Technology_Name = "technologyName",
  Lock_Status = "lockStatus",
  Responsible_Company = "responsibleCompany",
  Default_Asset_Name = "defaultAssetName",
  Incomplete_Datasets = "isIncompleteDataset"
}
